"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOOLBAR_BUTTON_CUSTOM_FONTS = void 0;

var _jodit = require("jodit");

var _fonts = require("../fonts");

var {
  memorizeExec
} = _jodit.Jodit.modules.Helpers;
/* eslint-disable import/prefer-default-export */

var TOOLBAR_BUTTON_CUSTOM_FONTS = 'fonts';
exports.TOOLBAR_BUTTON_CUSTOM_FONTS = TOOLBAR_BUTTON_CUSTOM_FONTS;
_jodit.Jodit.defaultOptions.customFonts = {
  moreFontsLabel: 'More fonts?'
};
_jodit.Jodit.defaultOptions.controls[TOOLBAR_BUTTON_CUSTOM_FONTS] = {
  tooltip: 'Fonts',
  list: [],
  icon: 'font',
  command: 'customFonts',
  childTemplate: (editor, key, value) => {
    var _editor$options$custo;

    var moreFontsLabel = (_editor$options$custo = editor.options.customFonts.moreFontsLabel) !== null && _editor$options$custo !== void 0 ? _editor$options$custo : _jodit.Jodit.defaultOptions.customFonts.moreFontsLabel;

    if (key === _fonts.CUSTOM_FONTS) {
      return "<img style=\"height:17px;margin-right:5px\" src=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAADFElEQVRoge2ZzU8TQRiHn/qBN/ViIQIxFW9y86AQrF7VgyYWw4eJf4KJH5GYoN7Af8CzFxNCOEhrTLwJfsV4Ve89GcGLEsFCaz3MO84C29KZ3dmi9Ek2s2n3/fh1952ZfQstWnghFdG+AzgPnAF6gSPAfvnuO1AEPgEvgefA14jxYicLFIA1oNrgsQbkgdNNyHcTPahfVidXBuaAG8BJIA3slSMNnAJuAvNyrbZ7BhxNOPe/jAJLkshPYAI4ZGGfBiaBZfHxAxiOOcctuYf5NaeAzgi+uoDpgL/xyNk1yAMJ+FvOo04QmutAhYTEjEqgCpDz4H8QI2bIg39AFbauiTu+ggBjmJrJ+AigZ6cpH84DpDA1U4jbeVYcLwPdlra6iG3oRM2EVWDA0rYuBXE64WDrIgTU1FwFZh1sQ+lArcJl7NYJjauQtMRclXMrdoV8dgHYA7wGFh0ScmUBeIfaFZyzNQ4TkpUxHyEpV/RjddbWMExIr4xvnNNx562Mx+Nw9g31jLvUB7jXCEC72C442q+jJM7a6lzT6Na91lGLffL9L9ukwx6t7cCqrUGYkCUZD9SxS9U5bK7ZyEEZrR+tMCFFGXtsncXAMRm/2BqGCfkoY79zOu70yfjZ1jBMyJyMl5zTcUfHfBGHs3bMFsV6q0D0LcoaplYik5dkJh1sXYU8FLtpB9ua9InTFZLfxp+wtN0SvZWfJr739DBSwIzEeuojQAb1+llFvY764q7EWAQO+woyjGk+DHrwfwXTfLjowf86xjFixojnMUuh7oQWUUF1bLyjxeia6YrgqxtTE8GjDIxES7MxhjA1s4yamm3WmTRqil3BtH+C/WAtJpE2agYzm+nA88At1JamHbX9b5PzfuA28GpD0lOowh5pphhQLZtZ7P5WKAFPUB36ILXEeOs8hpEGrgGPgQ+oKbSEWtyKwHvgkSRV741zmG0gJi4G2XyHy8DVZiblSi0xiUzNcfNficmxA8QksmjGTQ7VUdk5YrZrXyvIDKo2yoHPdmM6Lv8clzF35n6Tc4lMjgT/zm7RAvgDivgdI+jokSUAAAAASUVORK5CYII=\"/><span>".concat(moreFontsLabel, "</span>");
    }

    return "<span style='font-family: ".concat(key, "!important;'>").concat(value, "</span>");
  },
  isChildActive: (editor, control) => {
    var current = editor.s.current();

    if (current) {
      var activeFont = getComputedStyle(current.parentNode).getPropertyValue('font-family');
      return activeFont === "\"".concat(control.args[0].toString(), "\"");
    }

    return false;
  },
  exec: (editor, event, _ref) => {
    var {
      control
    } = _ref;
    return memorizeExec(editor, event, {
      control
    }, value => value);
  }
}; // Jodit needs an actual function here; => can't be used as constructors
// eslint-disable-next-line func-names

_jodit.Jodit.plugins.add('customFonts', function (editor) {
  editor.registerButton({
    name: TOOLBAR_BUTTON_CUSTOM_FONTS,
    group: 'font'
  });

  var callback = (command, showUI, value) => {
    if ((value === null || value === void 0 ? void 0 : value.toString()) === _fonts.CUSTOM_FONTS) {
      if (editor.options.customFonts.onAddFonts) {
        editor.options.customFonts.onAddFonts();
      }

      return false; // Don't execute native commands
    }

    editor.execCommand('fontname', showUI, value);
    return false; // Don't execute native commands
  };

  editor.registerCommand('customFonts', callback);
});